<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data.title" [separator]="false" />
    <email-text [contents]="data.p1" color="light" presetName="inline" size="small" />
    <email-margin [height]="16" />
    <hr />
    <email-margin [height]="16" />
  </ng-container>

  <ng-container body>
    <email-notification [body]="data.notification_html" [avatar]="data.avatar_url" />
    <email-margin [height]="32" />
    <email-button [href]="data.button_link" [label]="data.button_text" />
  </ng-container>

  <ng-container footer>
    <email-text [contents]="data.footer_p1" color="light" presetName="inline" size="small" /><br />
    <email-link
      [label]="data.footer_link_text"
      [href]="data.footer_link"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
